import { useMemo } from 'react'
import contacts from '../../../api/contacts/hooks'
import projects from '../../../api/projects/hooks'
import properties from '../../../api/properties/hooks'
import { enableFormValues } from '../../../utils/formUtils/forms'

export const useExportDataFormValues = (appModule: string) => {
    const formValuesQueries = {
        projects: {
            fields: ['status'],
            enabled: enableFormValues(['project'], appModule),
        },
        properties: {
            fields: ['status'],
            enabled: enableFormValues(['property'], appModule),
        },
        contacts: {
            fields: ['status'],
            enabled: enableFormValues(['contact', 'company'], appModule),
        },
    }

    const { data: projectValues, isPending: isPendingProjectValues } = projects.FormValues.useQuery(
        formValuesQueries.projects.fields,
        formValuesQueries.projects.enabled
    )

    const { data: propertyValues, isPending: isPendingPropertyValues } = properties.FormValues.useQuery(
        formValuesQueries.properties.fields,
        undefined,
        formValuesQueries.properties.enabled
    )

    const { data: contactValues, isPending: isPendingContactValues } = contacts.FormValues.useQuery(
        formValuesQueries.contacts.fields,
        undefined,
        formValuesQueries.contacts.enabled
    )

    const moduleQueryConfig = useMemo(
        () => ({
            project: {
                isPending: isPendingProjectValues,
                statusOptions: projectValues?.status,
            },
            property: {
                isPending: isPendingPropertyValues,
                statusOptions: propertyValues?.status,
            },
            contact: {
                isPending: isPendingContactValues,
                statusOptions: contactValues?.status,
            },
            company: {
                isPending: isPendingContactValues,
                statusOptions: contactValues?.status,
            },
        }),
        [isPendingProjectValues, projectValues, isPendingPropertyValues, propertyValues, isPendingContactValues, contactValues]
    )

    const currentModule = moduleQueryConfig[appModule as keyof typeof moduleQueryConfig]

    return {
        isPendingStatusOptions: currentModule?.isPending ?? false,
        statusOptions: currentModule?.statusOptions ?? [],
    }
}
